<template>
  <div class="phase-check">
      <van-button type="default" class="check_btn" block disabled>第{{round}}次申请第{{round_phase}}阶段</van-button>
      <div class="progress-list timeline">
        <div class="list-cells">
          <div class="list-cell" v-for="(pitem, pindex) in progress" :key="pindex">
            <div class="cell-point">
              <van-icon v-if="pindex == 0" size="" name="checked" color="#31BC08" />
              <div v-else class="point"></div>
            </div>
            <div class="cell-cont" :style="{'color':pitem.created==progress[0].created?'#31BC08':'#aaa'}">
              <div class="progress-text">
                {{pitem.content}}
              </div>
              <div v-if="pitem.remark"  class="progress-text">{{pitem.remark}}</div>
              <div class="progress-text" v-if="pitem.username&&pitem.username.indexOf('公益专员')>=0">
                当前操作为{{pitem.username}}操作
              </div>
              <div class="cell-title" v-if="pitem.created" >{{splitDate(pitem.created, 'before')}}&nbsp;{{splitDate(pitem.created, 'after')}}</div>
            </div>
          </div>
        </div>
      </div>
  </div>
  
</template>

<script>
import { newApplysGoingByPhaseDesc } from '@/api/publicWelfareStaff';
import { mapState } from "vuex";

export default {
  data() {
    return {
      papid:'',

      round:'1',
      round_phase:'1',

      progress:'',

      name:'',
    }
  },
  async created(){
    this.papid=this.$route.query.papid;
    this.phase=this.$route.query.phase
    this.round=this.$route.query.round
    this.round_phase=this.$route.query.show_phase
    this.name=this.publicWelfareStaff.checkin_info.name
    await this.getData()
  },
  computed: {
    ...mapState(['publicWelfareStaff']),
  },
  methods:{
    async getData(){
      let self=this;
      await newApplysGoingByPhaseDesc({papid: this.papid,phase:this.phase}).then(res=>{
        self.progress=[]
        let progress=[]
        if(res.data){
          res.data.log.forEach(ele => {
            progress.push(ele)
          })
          self.progress=this.Unrepeated(progress)
        }
      }).catch((err) => {
        Toast("加载失败,请刷新重试")
      })
      if(self.progress.length==0) self.progress.push({content:'暂无记录'})
    },
    Unrepeated(rawData){
      let timeArr=[] //记录日志的创建时间
      let needDelete=[] //需要删除的元素序号
      let outData=[]
      let temp=rawData
      for (let i in rawData){
        if(timeArr.length==0){
          timeArr.push(rawData[i].created)
        }else if(timeArr.indexOf(rawData[i].created)>=0){
          needDelete.push(i)
        }else{
          timeArr.push(rawData[i].created)
        }
      }
      needDelete.forEach(index=>{temp.splice(index,1,'已删除')})
      if(temp) outData=temp.filter(ele=>{return ele!='已删除'})

      console.log("输入:",rawData)
      console.log("时间记录:",timeArr)
      console.log("需要删除的元素序号:",needDelete)
      console.log("输出:",outData)

      return outData
    },
    // getRound_phase(){
    //   let round=parseInt(this.round)
    //   let phase=parseInt(this.phase)
    //   let minus=0
    //   let round_phase=0
    //   minus=round==1?0:round==2?2:round==3?27:0
    //   console.log("round:",round,"phase:",phase,"round_phase:",round_phase,"minus:",minus)

    //   round_phase=phase-minus
    //   return round_phase
    // },
    splitDate(date, local) {
      let arr = date.trim().split(/\s+/)
      if (local == 'before') {
        return arr[0]
      }
      if (local == 'after') {
        return arr[1]
      }
    },
  }
}
</script>

<style lang="less" scoped> 
.phase-check{
    min-height: 100vh;
    background-color: #f9f9f9;
    padding: 10px 15px;
    font-size: 16px;
    ::v-deep .check_btn{
      ::v-deep .van-button__text{
        font-size:14px;
        color: #9A9A9A!important;

      }
      margin-bottom: 15px;
    }
    .timeline{
      font-size: 16px;
      padding: 20px;
      min-height: 25vh;
      line-height: 20px;
      border-radius: 10px;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
      background: white;
      .cell-point{
          .van-icon{
            top:0;
          }
        }
        .cell-cont{
          padding: 0 0 20px 0;
          .cell-title{
            font-size: 12px !important;
            // padding-bottom: 5px;
          }
          .progress-text{
            font-size: 15px;
          }
        }
    }
}
</style>